import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppointmentDataBuilder } from './appointment-data.builder';
import { AppointmentDataDispatcher } from './appointment-data.dispatcher';
import { AppointmentDataEffects } from './appointment-data.effects';
import { FEATURE_NAME, reducer } from './appointment-data.reducer';
import { AppointmentDataService } from './appointment-data.service';
import { AppointmentDataStore } from './appointment-data.store';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([AppointmentDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
})
export class AppointmentDataModule {
  static forRoot(): ModuleWithProviders<AppointmentDataModule> {
    return {
      ngModule: AppointmentDataModule,
      providers: [
        AppointmentDataDispatcher,
        AppointmentDataService,
        AppointmentDataStore,
        AppointmentDataBuilder,
      ],
    };
  }
}
